export default function yatarget(id){
	if( location.href.indexOf('msk') === -1 ) yaCounter46890516.reachGoal(id);
}